import { render, staticRenderFns } from "./PickUpReady.vue?vue&type=template&id=23f0de46&"
import script from "./PickUpReady.vue?vue&type=script&lang=ts&"
export * from "./PickUpReady.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports